import { css } from '@emotion/react';

import { campaignManagerTheme } from '@campaign-manager/theme';

export const inputFieldContainer = css`
  display: inline-flex;
  align-items: center;
  position: relative;
  padding-top: 0px;
  padding-bottom: 0px;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.4375em;
  color: rgba(0, 0, 0, 0.87);
  transition: background-color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  background: none;
`;

export const disabled = css`
  color: rgba(0, 0, 0, 0.38);
  cursor: default;
`;

export const small = css`
  &.standard .inputFieldContainerContent {
    padding-top: 0px;
    padding-bottom: 0px;
    min-height: 20px;
    line-height: 20px;
  }

  &.filled .inputFieldContainerContent,
  &.outlined .inputFieldContainerContent {
    padding-top: 2px;
    padding-bottom: 2px;
  }
`;

export const medium = css`
  &.standard .inputFieldContainerContent,
  &.filled .inputFieldContainerContent,
  &.outlined .inputFieldContainerContent {
    padding-top: 6px;
    padding-bottom: 6px;
  }
`;

export const standard = css`
  &:before {
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
    left: 0;
    bottom: 0;
    content: ' ';
    position: absolute;
    right: 0;
    -webkit-transition: border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1)
      0ms;
    transition: border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    pointer-events: none;
  }
  &.disabled {
    &:before {
      border-bottom-style: dotted;
    }
  }
  &:not(.disabled):hover {
    &:before {
      border-bottom: 2px solid rgba(0, 0, 0, 0.87);
    }
  }

  &:after {
    border-bottom: 2px solid #ffb657;
    left: 0;
    bottom: 0;
    content: ' ';
    position: absolute;
    right: 0;
    -webkit-transform: scaleX(0);
    -moz-transform: scaleX(0);
    -ms-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transition: -webkit-transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    pointer-events: none;
  }
`;

export const outlined = css`
  padding-left: 12px;

  background: #ffffff;

  border-radius: 8px;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  min-width: 0%;
  border-color: rgba(0, 0, 0, 0.23);

  &:hover {
    border-color: rgba(0, 0, 0, 0.87);
  }
`;

export const filled = css`
  padding-left: 12px;
  border-radius: 8px;

  background-color: oklch(from ${campaignManagerTheme.color.groundZeroSurface} calc(l - 0.02) calc(c + 0.001) h / 0.95);
  box-shadow: ${campaignManagerTheme.shadow.inputInset};

  &:hover {
    background-color: oklch(from ${campaignManagerTheme.color.groundZeroSurface} calc(l - 0.03) calc(c + 0.001) h / 0.95);
  }
`;

export const inputFieldContainerContent = css`
  box-sizing: content-box;
  display: block;

  min-height: 26px;
  min-width: 0;
  width: 100%;

  font-size: var(--fontSize-small);

  background: none;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const startAdornment = css`
  padding-left: 12px;
`;

export const endAdornment = css`
  padding-right: 12px;
`;

export const error = css`
  border: 2px solid ${campaignManagerTheme.color.red};

  &.filled {
    background-color: ${campaignManagerTheme.color.paleRedOverlay};
  }
`;
